module.exports = __webpack_public_path__ + "img/source_sw-con04.27741658.png";